var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"line-bar-chart-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"line-bar-chart",attrs:{"id":_vm.title}})])
}
var staticRenderFns = []

export { render, staticRenderFns }